/* eslint-disable filenames/match-regex */
export const LIMIT = {
    MIN_X: -3000,
    MAX_X: 3000,
    MIN_Y: -3000,
    MAX_Y: 5000
};
